import { LoginActionConst } from "../Constants/AuthConstants";

const initialState = {
  loader: false,
  loginSuccess: null,
  loginError: null,
  user: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginActionConst.USER_LOGIN_REQUEST:
      return {
        ...state,
        loader: true,
        loginError: null,
        loginSuccess: null,
      };

    case LoginActionConst.USER_LOGIN_SUCC:
      return {
        ...state,
        loader: false,
        loginSuccess: action.result,
        loginError: null,
        user: action.result.data,
      };

    case LoginActionConst.USER_LOGIN_FAIL:
      return {
        ...state,
        loader: false,
        loginError: action.result,
        loginSuccess: null,
        user: null,
      };

    case LoginActionConst.USER_LOGOUT:
      return {
        ...state,
        loader: false,
        loginSuccess: null,
        loginError: null,
        user: null,
      };

    default:
      return state;
  }
};

export default authReducer;
